import { useDefault } from '../../../../common';

export class PreferenceOption {
  id: string;
  name: string;
  selected: boolean;

  constructor(optionData: any) {
    this.id = useDefault(optionData.id, '');
    this.name = useDefault(optionData.name, '');
    this.selected = useDefault(optionData.selected, false);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/stay-preferences/preference-option.model.ts